import React, { useContext, useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { fmDataContext } from "../../Context/FmData";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import LoadingCircle from "../LoadingCircle/LoadingCircle";
import { fmPageHeadersContext } from "../../Context/PageHeadersContext";
import userCan from "../../helpers/userCan";
import "swiper/css";
import "swiper/css/pagination";
import Swal from "sweetalert2/dist/sweetalert2.all.min";
import "@sweetalert2/theme-dark/dark.min.css";
import jwtDecode from "jwt-decode";
import { authenticationContext } from "../../Context/AuthContext";

const PageHeaderDetails = () => {
  let [mounted, setMounted] = useState(false);

  let { pageHeaderId } = useParams();
  let [params, setParams] = useSearchParams();

  let { baseUrl, navigate, showData, editItemExistence, globalCrumbs, setGlobalCrumbs } = useContext(fmDataContext);
  let { user } = useContext(authenticationContext);

  let [currentPageHeader, setCurrentPageHeader] = useState({});
  let onlyTrashed = params.get("archived");
  let [isCurrentPageHeaderLoading, setIsCurrentPageHeaderLoading] = useState(true);

  let [isSoftDeleteLoading, setIsSoftDeleteLoading] = useState(false);
  let [isForceDeleteLoading, setIsForceDeleteLoading] = useState(false);
  let [isRestoreLoading, setIsRestoreLoading] = useState(false);

  let { setPageHeaderMsg } = useContext(fmPageHeadersContext);

  let userToken = jwtDecode(localStorage.getItem("userToken")).accessToken;

  const softDeletePageHeader = (reqMethod, pathName, headers, setLoading) => {
    if (userCan("fm_page_header_soft_delete")) {
      Swal.fire({
        title: "Are you sure?",
        html: `<p class="mb-0 line-clamp-2">You will delete <span class="fu-text-light-gray">${currentPageHeader.data.page_title} header image</span></p>`,
        icon: "warning",
        showCancelButton: true,
        customClass: {
          cancelButton: "popup-btn",
          confirmButton: "popup-btn",
        },
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          editItemExistence(reqMethod, pathName, headers, setLoading)
            .then((response) => {
              setPageHeaderMsg(`${currentPageHeader.data.page_title} header image Deleted Successfully`);
              navigate("/fm-page-headers");
            })
            .catch((error) => {
              navigate("/not-found");
            });
        }
      });
    } else {
      navigate("/not-found");
    }
  };

  const restorePageHeader = (reqMethod, pathName, headers, setLoading) => {
    if (userCan("fm_page_header_restore_trashed")) {
      Swal.fire({
        title: "Are you sure?",
        html: `<p class="mb-0 line-clamp-2">You will restore <span class="fu-text-light-gray">${currentPageHeader.data.page_title} header image</span></p>`,
        icon: "question",
        showCancelButton: true,
        customClass: {
          cancelButton: "popup-btn",
          confirmButton: "popup-btn",
        },
        confirmButtonText: "Yes, restore it!",
      }).then((result) => {
        if (result.isConfirmed) {
          editItemExistence(reqMethod, pathName, headers, setLoading)
            .then((response) => {
              setPageHeaderMsg(`${currentPageHeader.data.page_title} header image restored Successfully`);
              navigate("/fm-page-headers");
            })
            .catch((error) => {
              navigate("/not-found");
            });
        }
      });
    } else {
      navigate("/not-found");
    }
  };

  const forceDeletePageHeader = (reqMethod, pathName, headers, setLoading) => {
    Swal.fire({
      title: "Are you sure?",
      html: `<p class="mb-0 line-clamp-2">You will delete <span class="fu-text-light-gray">${currentPageHeader.data.page_title} header image permanently</span></p><p class="mb-0">You won't be able to revert this!</p>`,
      icon: "warning",
      showCancelButton: true,
      customClass: {
        cancelButton: "popup-btn",
        confirmButton: "popup-btn",
      },
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        if (userCan("fm_page_header_force_delete")) {
          editItemExistence(reqMethod, pathName, headers, setLoading)
            .then((response) => {
              setPageHeaderMsg(`${currentPageHeader.data.page_title} header image Deleted Permanently Successfully`);
              navigate("/fm-page-headers");
            })
            .catch((error) => {
              navigate("/not-found");
            });
        } else {
          navigate("/not-found");
        }
      }
    });
  };

  const getPageHeader = (reqMethod, pathName, setLoading = setIsCurrentPageHeaderLoading, headers, params) => {
    showData(reqMethod, pathName, setLoading, headers, params)
      .then((response) => {
        if (response.data.data.image.includes("via.placeholder.com")) {
          response.data.data.image = response.data.data.image.replace("http://127.0.0.1:8000/storage/", "");
        }

        setCurrentPageHeader(response.data);
        setLoading(false);
      })
      .catch((error) => {
        navigate("/not-found");
      });
  };

  useEffect(() => {
    getPageHeader(
      "GET",
      `${baseUrl}fm-page-header/${pageHeaderId}`,
      setIsCurrentPageHeaderLoading,
      {
        Accept: "application/json",
        "fm-api-secret-key": process.env.REACT_APP_FM_API_SECRET_KEY,
        Authorization: `Bearer ${userToken}`,
      },
      {
        only_trashed: onlyTrashed,
      }
    );
    setMounted(true);
  }, []);

  useEffect(() => {
    if (mounted) {
      getPageHeader(
        "GET",
        `${baseUrl}fm-page-header/${pageHeaderId}`,
        setIsCurrentPageHeaderLoading,
        {
          Accept: "application/json",
          "fm-api-secret-key": process.env.REACT_APP_FM_API_SECRET_KEY,
          Authorization: `Bearer ${userToken}`,
        },
        {
          only_trashed: onlyTrashed,
        }
      );
    }
  }, [pageHeaderId]);

  useEffect(() => {
    if (mounted && currentPageHeader.data) {
      let globalCrumbsUpdated = globalCrumbs.map((crumb) => {
        if (crumb.name === pageHeaderId.toUpperCase()) {
          crumb.name = `${currentPageHeader.data.page_title} header image`.toUpperCase();
        }
        return crumb;
      });
      setGlobalCrumbs(globalCrumbsUpdated);
    }
  }, [currentPageHeader]);

  return (
    <>
      {!isCurrentPageHeaderLoading ? (
        <>
          <div className="page-heading">
            <div className="heading-img-container" style={{ backgroundImage: `url(${currentPageHeader.data.image})` }}></div>
          </div>
          <div className="container position-relative pt-5">
            <div className="mb-2">
              <h1 className="page-heading-title mb-0">{currentPageHeader.data.page_title.toUpperCase()}</h1>
            </div>
            <div className="d-flex flex-wrap align-items-center mb-4">
              {currentPageHeader.data.deleted_at === null ? (
                userCan("fm_page_header_update") ? (
                  <div className="me-2 my-1 my-sm-0">
                    <Link to={`/fm-page-headers/update/${currentPageHeader.data.key}`} className={`btn fu-btn-sm fu-btn-gray ${isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? "disabled" : ""}`} disabled={isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? true : false}>
                      <span className="btn-bg"></span>
                      Edit
                    </Link>
                  </div>
                ) : (
                  ""
                )
              ) : (
                ""
              )}

              {currentPageHeader.data.deleted_at === null ? (
                userCan("fm_page_header_soft_delete") ? (
                  <div className="mx-2 my-1 my-sm-0">
                    <button
                      className={`btn fu-btn-sm fu-btn-gray ${isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? "disabled" : ""}`}
                      onClick={() =>
                        softDeletePageHeader(
                          "DELETE",
                          `${baseUrl}fm-page-headers/delete/${currentPageHeader.data.key}`,
                          {
                            Accept: "application/json",
                            "fm-api-secret-key": process.env.REACT_APP_FM_API_SECRET_KEY,
                            Authorization: `Bearer ${user.accessToken}`,
                          },
                          setIsSoftDeleteLoading
                        )
                      }
                      disabled={isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? true : false}>
                      <span className="btn-bg"></span>
                      Delete
                    </button>
                  </div>
                ) : (
                  ""
                )
              ) : (
                ""
              )}

              {currentPageHeader.data.deleted_at !== null ? (
                userCan("fm_page_header_restore_trashed") ? (
                  <div className="mx-2 my-1 my-sm-0">
                    <button
                      className={`btn fu-btn-sm fu-btn-gray ${isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? "disabled" : ""}`}
                      onClick={() =>
                        restorePageHeader(
                          "PATCH",
                          `${baseUrl}fm-page-headers/restore/${currentPageHeader.data.key}`,
                          {
                            Accept: "application/json",
                            "fm-api-secret-key": process.env.REACT_APP_FM_API_SECRET_KEY,
                            Authorization: `Bearer ${user.accessToken}`,
                          },
                          setIsRestoreLoading
                        )
                      }
                      disabled={isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? true : false}>
                      <span className="btn-bg"></span>
                      Restore
                    </button>
                  </div>
                ) : (
                  ""
                )
              ) : (
                ""
              )}
              {userCan("fm_page_header_force_delete") ? (
                <div className="ms-2 my-1 my-sm-0">
                  <button
                    className={`btn fu-btn-sm fu-btn-gray ${isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? "disabled" : ""}`}
                    onClick={() =>
                      forceDeletePageHeader(
                        "DELETE",
                        `${baseUrl}fm-page-headers/force-delete/${currentPageHeader.data.key}`,
                        {
                          Accept: "application/json",
                          "fm-api-secret-key": process.env.REACT_APP_FM_API_SECRET_KEY,
                          Authorization: `Bearer ${user.accessToken}`,
                        },
                        setIsForceDeleteLoading
                      )
                    }
                    disabled={isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? true : false}>
                    <span className="btn-bg"></span>
                    Force Delete
                  </button>
                </div>
              ) : (
                ""
              )}

              {isForceDeleteLoading || isRestoreLoading || isSoftDeleteLoading ? (
                <div className="position-relative ms-4">
                  <LoadingCircle circleCont={35} icon={30} loader={35} dot={35} />
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="page-header-tags">
              <div className="mb-4 info-tags-container justify-content-start">
                {currentPageHeader.data._id ? (
                  <>
                    <div className="mx-1 my-1 info-tag">
                      <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">#ID: </span>
                      <span className="d-inline-flex justify-content-center align-items-center">{currentPageHeader.data._id}</span>
                    </div>
                  </>
                ) : (
                  ""
                )}
                {currentPageHeader.data.key ? (
                  <>
                    <div className="mx-1 my-1 info-tag">
                      <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">#KEY: </span>
                      <span className="d-inline-flex justify-content-center align-items-center">{currentPageHeader.data.key}</span>
                    </div>
                  </>
                ) : (
                  ""
                )}

                {currentPageHeader.data.created_at ? (
                  userCan("created_at_show") ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">CREATED AT: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{new Date(currentPageHeader.data.created_at).toLocaleString("en-US", { timeZone: "Africa/Cairo", hour12: true })}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {currentPageHeader.data.updated_at ? (
                  userCan("updated_at_show") ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">UPDATED AT: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{new Date(currentPageHeader.data.updated_at).toLocaleString("en-US", { timeZone: "Africa/Cairo", hour12: true })}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {currentPageHeader.data.deleted_at ? (
                  userCan("deleted_at_show") ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">DELETED AT: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{new Date(currentPageHeader.data.deleted_at).toLocaleString("en-US", { timeZone: "Africa/Cairo", hour12: true })}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {currentPageHeader.data.created_by ? (
                  userCan("created_by_show") ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">CREATED BY, NAME: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{currentPageHeader.data.created_by.name}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {currentPageHeader.data.created_by ? (
                  userCan("created_by_show") ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">CREATED BY, #ID: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{currentPageHeader.data.created_by._id}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {currentPageHeader.data.created_by ? (
                  userCan("created_by_show") ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">CREATED BY, KEY: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{currentPageHeader.data.created_by.key}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {currentPageHeader.data.updated_by ? (
                  userCan("updated_by_show") ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">UPDATED BY, NAME: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{currentPageHeader.data.updated_by.name}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {currentPageHeader.data.updated_by ? (
                  userCan("updated_by_show") ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">UPDATED BY, #ID: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{currentPageHeader.data.updated_by._id}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
                {currentPageHeader.data.updated_by ? (
                  userCan("updated_by_show") ? (
                    <>
                      <div className="mx-1 my-1 info-tag">
                        <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">UPDATED BY, KEY: </span>
                        <span className="d-inline-flex justify-content-center align-items-center">{currentPageHeader.data.updated_by.key}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <LoadingScreen />
      )}
    </>
  );
};

export default PageHeaderDetails;
